var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("Copyright © 2021 All rights reserved | Javier Bryan ")])])
}]

export { render, staticRenderFns }